module.exports = __webpack_public_path__ + "img/136.dc1d2a93.jpg";